import React,{ useState, useEffect } from 'react';

import bkg_vigne from '../../assets/images/bkg-vigne.jpg';
import maison from "../../assets/images/maison.svg";
import {urlBase} from "../../config/Globals";
import ArticleSevice from "../../service/Article";
import {Partenaires} from "../Home/Partenaires";

export const QueDitLaRecherche = ({ rubrique }) => {

    const[articles, setArticles] = useState([]);
    const[loadingArticles, setLoadingArticles] = useState(1);
    const fetchArticles = async(id) => {
        try{
            const data = await ArticleSevice.findAllInRubrique(id);
            setArticles(data);
            setLoadingArticles(false);
        }catch (error){

        }
    }
    useEffect(() => {
        if(rubrique.id) {
            fetchArticles(rubrique.id);
        }
    }, [rubrique.id]);

    return (
        <>
            <main class="type que-dit-la-recherche">
                <section id="savoir-plus" className="pt-md-5 pt-lg-0 pb-md-5 d-flex align-items-center bg-gris position-relative">
                    <img src={bkg_vigne} alt="" className="hero-bg-image"/>
                    <div className="container-top-custom-2 container-md px-md-4 pb-md-5 position-relative z-1">
                        <div className="row flex-column align-items-center justify-content-center">
                            <div className="col-12 col-lg-10 bg-white pb-5 p-4 p-md-5 position-relative d-flex flex-wrap">
                                <div className="col-12">
                                    <nav aria-label="breadcrumb" className="mb-4">
                                        <ol className="custom-breadcrumb">
                                            <li className="breadcrumb-item-custom">
                                                <a href={urlBase} className="breadcrumb-link-home">
                                                    <img src={maison} alt="Accueil" className="breadcrumb-icon"/>
                                                </a>
                                            </li>
                                            <li className="breadcrumb-separator">•</li>

                                            <li className="breadcrumb-item-custom">
                                                <a href={urlBase + 'tout-savoir-sur-la-flavescence-doree'}
                                                   className="breadcrumb-link">
                                                    Tout savoir sur la flavescence dorée
                                                </a>
                                            </li>

                                            <li className="breadcrumb-separator">•</li>

                                            <li className="breadcrumb-item-custom active" aria-current="page">
                                                {rubrique.titre}
                                            </li>
                                        </ol>
                                    </nav>
                                    <h1 className="display-6 fw-sb mb-0">{rubrique.titre}</h1>
                                    <div className="row pt-4 pt-md-5 g-4 g-md-5 justify-content-center">
                                        {
                                            articles.map((article, index) => (

                                                    <div className="col-lg-6 col-xl-4 d-flex">
                                                        <div
                                                            className="card border-0 rounded-0 w-100 card-bg-beige d-flex flex-column justify-content-between">
                                                            <div className="text-center text-lg-start">
                                                                <div className="p-4 p-xl-5">
                                                                    <h3 className="fw-sb text-body mb-3">{article.titre}</h3>
                                                                </div>
                                                            </div>
                                                            <div className="p-4 p-xl-5 pt-0 pt-xl-0 text-center text-lg-start">
                                                                <a href={urlBase+"tout-savoir-sur-la-flavescence-doree/"+rubrique.wording+'/'+article.id} className="btn btn-outline-custom d-inline-block">En savoir plus</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Partenaires/>
            </main>
        </>
    );
}